export default __webpack_public_path__ + "images/xrp_814ed4.svg";